import angular from 'angular';

import Component from './dateTimeRangePicker.component';
import Modal from './dateTimeRangePicker.modal.component';
import DateSelection from './dateSelections.component';
import DateRangeDisplay from './dateRangeDisplay.component';
import CalendarTimePicker from './calenderTimePicker.component';
import Picker from './picker.component';
import Service from './dateTimeRangePicker.service';

import './dateTimeRangePicker.component.scss';

export default angular
  .module('petroCloud.dateTimeRangePicker', [])
  .component(Component.name, Component)
  .component(Modal.name, Modal)
  .component(DateSelection.name, DateSelection)
  .component(DateRangeDisplay.name, DateRangeDisplay)
  .component(CalendarTimePicker.name, CalendarTimePicker)
  .component(Picker.name, Picker)
  .service('DateTimeRangePickerService', Service)
  .name;
